import { render } from "./PlaceEvents.vue?vue&type=template&id=760db552&scoped=true"
import script from "./PlaceEvents.vue?vue&type=script&lang=js"
export * from "./PlaceEvents.vue?vue&type=script&lang=js"

import "./PlaceEvents.vue?vue&type=style&index=0&id=760db552&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-760db552"]])

export default __exports__